import { FC } from 'react'

import { ComponentFullWidthImageModel } from 'api'
import { Markdown } from 'components/markdown'
import { ContentImage } from 'sections/articles/content-components/content-image'
import { cn } from 'utils'

import common from '../common.module.css'
import classes from './full-width-image.module.css'
import { BaseContentComponentProps } from '../types'

interface FullWidthImageProps
  extends BaseContentComponentProps<
    Pick<ComponentFullWidthImageModel, 'description' | 'image' | 'with_border'>
  > {}

export const FullWidthImage: FC<FullWidthImageProps> = ({ data }) => {
  return (
    <figure className={cn(classes.figure, data.with_border && common.withBorder)}>
      <ContentImage item={data.image} layout="responsive" />
      <figcaption className={classes.figcaption}>
        <Markdown>{data.description}</Markdown>
      </figcaption>
    </figure>
  )
}
